export type BrazilStates =
  | 'AC'
  | 'AL'
  | 'AP'
  | 'AM'
  | 'BA'
  | 'CE'
  | 'DF'
  | 'ES'
  | 'GO'
  | 'MA'
  | 'MT'
  | 'MS'
  | 'MG'
  | 'PA'
  | 'PB'
  | 'PR'
  | 'PE'
  | 'PI'
  | 'RJ'
  | 'RN'
  | 'RS'
  | 'RO'
  | 'RR'
  | 'SC'
  | 'SP'
  | 'SE'
  | 'TO';

export interface InfoState {
  abbreviation: BrazilStates;
  name: string;
  region: 'Norte' | 'Nordeste' | 'Centro-Oeste' | 'Sudeste' | 'Sul';
}

export const DDD_MAP: Record<string, InfoState> = {
  // North
  '68': { abbreviation: 'AC', name: 'Acre', region: 'Norte' },
  '96': { abbreviation: 'AP', name: 'Amapá', region: 'Norte' },
  '92': { abbreviation: 'AM', name: 'Amazonas', region: 'Norte' },
  '97': { abbreviation: 'AM', name: 'Amazonas', region: 'Norte' },
  '91': { abbreviation: 'PA', name: 'Pará', region: 'Norte' },
  '93': { abbreviation: 'PA', name: 'Pará', region: 'Norte' },
  '94': { abbreviation: 'PA', name: 'Pará', region: 'Norte' },
  '69': { abbreviation: 'RO', name: 'Rondônia', region: 'Norte' },
  '95': { abbreviation: 'RR', name: 'Roraima', region: 'Norte' },
  '63': { abbreviation: 'TO', name: 'Tocantins', region: 'Norte' },

  // Northeast
  '82': { abbreviation: 'AL', name: 'Alagoas', region: 'Nordeste' },
  '71': { abbreviation: 'BA', name: 'Bahia', region: 'Nordeste' },
  '73': { abbreviation: 'BA', name: 'Bahia', region: 'Nordeste' },
  '74': { abbreviation: 'BA', name: 'Bahia', region: 'Nordeste' },
  '75': { abbreviation: 'BA', name: 'Bahia', region: 'Nordeste' },
  '77': { abbreviation: 'BA', name: 'Bahia', region: 'Nordeste' },
  '85': { abbreviation: 'CE', name: 'Ceará', region: 'Nordeste' },
  '88': { abbreviation: 'CE', name: 'Ceará', region: 'Nordeste' },
  '98': { abbreviation: 'MA', name: 'Maranhão', region: 'Nordeste' },
  '99': { abbreviation: 'MA', name: 'Maranhão', region: 'Nordeste' },
  '83': { abbreviation: 'PB', name: 'Paraíba', region: 'Nordeste' },
  '81': { abbreviation: 'PE', name: 'Pernambuco', region: 'Nordeste' },
  '87': { abbreviation: 'PE', name: 'Pernambuco', region: 'Nordeste' },
  '86': { abbreviation: 'PI', name: 'Piauí', region: 'Nordeste' },
  '89': { abbreviation: 'PI', name: 'Piauí', region: 'Nordeste' },
  '84': { abbreviation: 'RN', name: 'Rio Grande do Norte', region: 'Nordeste' },
  '79': { abbreviation: 'SE', name: 'Sergipe', region: 'Nordeste' },

  // Central-West
  '61': { abbreviation: 'DF', name: 'Distrito Federal', region: 'Centro-Oeste' },
  '62': { abbreviation: 'GO', name: 'Goiás', region: 'Centro-Oeste' },
  '64': { abbreviation: 'GO', name: 'Goiás', region: 'Centro-Oeste' },
  '65': { abbreviation: 'MT', name: 'Mato Grosso', region: 'Centro-Oeste' },
  '66': { abbreviation: 'MT', name: 'Mato Grosso', region: 'Centro-Oeste' },
  '67': { abbreviation: 'MS', name: 'Mato Grosso do Sul', region: 'Centro-Oeste' },

  // Southeast
  '27': { abbreviation: 'ES', name: 'Espírito Santo', region: 'Sudeste' },
  '28': { abbreviation: 'ES', name: 'Espírito Santo', region: 'Sudeste' },
  '31': { abbreviation: 'MG', name: 'Minas Gerais', region: 'Sudeste' },
  '32': { abbreviation: 'MG', name: 'Minas Gerais', region: 'Sudeste' },
  '33': { abbreviation: 'MG', name: 'Minas Gerais', region: 'Sudeste' },
  '34': { abbreviation: 'MG', name: 'Minas Gerais', region: 'Sudeste' },
  '35': { abbreviation: 'MG', name: 'Minas Gerais', region: 'Sudeste' },
  '37': { abbreviation: 'MG', name: 'Minas Gerais', region: 'Sudeste' },
  '38': { abbreviation: 'MG', name: 'Minas Gerais', region: 'Sudeste' },
  '21': { abbreviation: 'RJ', name: 'Rio de Janeiro', region: 'Sudeste' },
  '22': { abbreviation: 'RJ', name: 'Rio de Janeiro', region: 'Sudeste' },
  '24': { abbreviation: 'RJ', name: 'Rio de Janeiro', region: 'Sudeste' },
  '11': { abbreviation: 'SP', name: 'São Paulo', region: 'Sudeste' },
  '12': { abbreviation: 'SP', name: 'São Paulo', region: 'Sudeste' },
  '13': { abbreviation: 'SP', name: 'São Paulo', region: 'Sudeste' },
  '14': { abbreviation: 'SP', name: 'São Paulo', region: 'Sudeste' },
  '15': { abbreviation: 'SP', name: 'São Paulo', region: 'Sudeste' },
  '16': { abbreviation: 'SP', name: 'São Paulo', region: 'Sudeste' },
  '17': { abbreviation: 'SP', name: 'São Paulo', region: 'Sudeste' },
  '18': { abbreviation: 'SP', name: 'São Paulo', region: 'Sudeste' },
  '19': { abbreviation: 'SP', name: 'São Paulo', region: 'Sudeste' },

  // South
  '41': { abbreviation: 'PR', name: 'Paraná', region: 'Sul' },
  '42': { abbreviation: 'PR', name: 'Paraná', region: 'Sul' },
  '43': { abbreviation: 'PR', name: 'Paraná', region: 'Sul' },
  '44': { abbreviation: 'PR', name: 'Paraná', region: 'Sul' },
  '45': { abbreviation: 'PR', name: 'Paraná', region: 'Sul' },
  '46': { abbreviation: 'PR', name: 'Paraná', region: 'Sul' },
  '51': { abbreviation: 'RS', name: 'Rio Grande do Sul', region: 'Sul' },
  '53': { abbreviation: 'RS', name: 'Rio Grande do Sul', region: 'Sul' },
  '54': { abbreviation: 'RS', name: 'Rio Grande do Sul', region: 'Sul' },
  '55': { abbreviation: 'RS', name: 'Rio Grande do Sul', region: 'Sul' },
  '47': { abbreviation: 'SC', name: 'Santa Catarina', region: 'Sul' },
  '48': { abbreviation: 'SC', name: 'Santa Catarina', region: 'Sul' },
  '49': { abbreviation: 'SC', name: 'Santa Catarina', region: 'Sul' },
};

/**
 * get information of the Brazilian state by DDD
 * @param ddd - DDD code with or without special characters (ex: "11", "(11)", "011")
 * @returns information of the state or undefined if DDD is invalid
 */
export function getStateByDDD(ddd: string): InfoState | undefined {
  const dddLimpo = ddd.replace(/\D/g, '');

  const dddNormalizado = dddLimpo.slice(-2);

  return DDD_MAP[dddNormalizado];
}

/**
 * validate if the DDD is valid
 * @param ddd - DDD code
 * @returns true if the DDD exists in Brazil
 */
export function isDDDValid(ddd: string): boolean {
  return getStateByDDD(ddd) !== undefined;
}

/**
 * get the abbreviation of the state by DDD
 * @param ddd - DDD code
 * @returns abbreviation of the state or undefined
 */
export function getStateAbbreviationByDDD(ddd: string): string | undefined {
  return `${getStateByDDD(ddd)?.abbreviation} - ${getStateByDDD(ddd)?.name}`;
}

/**
 * get all DDDs of a state
 * @param abbreviation - abbreviation of the state (ex: "SP", "RJ")
 * @returns Array with all DDDs of the state
 */
export function getDDDsByState(name: BrazilStates): string[] {
  return (
    Object.entries(DDD_MAP)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, info]) => info.name === name)
      .map(([ddd]) => ddd)
  );
}
